export function Replacer({ children }) {
    return (<>
        {children}
      </>);
}
